import React, { useEffect, useState } from 'react';
import { normalizePageSections } from './siteContent';

const paragraphStyle = {
  margin: '0 0 1.25rem 0',
  fontSize: '1.1rem',
  lineHeight: '1.7',
};

function EditableMultiSectionContent({ sections, isAdmin, isLoading, onSave, style = {} }) {
  const [draftSections, setDraftSections] = useState(() => normalizePageSections(sections));

  useEffect(() => {
    setDraftSections(normalizePageSections(sections));
  }, [sections]);

  if (isLoading) {
    return <p style={{ color: '#6b7280', ...style }}>Loading page content...</p>;
  }

  if (isAdmin) {
    return (
      <div style={{ display: 'grid', gap: '20px', marginBottom: '40px', ...style }}>
        {draftSections.map((section, index) => (
          <label key={index} style={{ display: 'grid', gap: '8px' }}>
            <span style={{ fontWeight: '600', color: '#374151' }}>
              Paragraph {index + 1}
            </span>
            <textarea
              value={section}
              onChange={(e) => {
                const nextSections = [...draftSections];
                nextSections[index] = e.target.value;
                setDraftSections(nextSections);
              }}
              onBlur={() => onSave(normalizePageSections(draftSections))}
              rows={5}
              style={{
                width: '100%',
                outline: '2px dashed #93c5fd',
                borderRadius: '8px',
                padding: '12px',
                border: '1px solid #d1d5db',
                resize: 'vertical',
                fontFamily: 'inherit',
                fontSize: '1.1rem',
                lineHeight: '1.7',
                whiteSpace: 'pre-wrap',
              }}
              title="Admin edit mode: each box is its own paragraph. Changes save when you click away."
            />
          </label>
        ))}
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '40px', ...style }}>
      {normalizePageSections(sections)
        .map(section => section.trim())
        .filter(Boolean)
        .map((section, index) => (
          <p key={index} style={paragraphStyle}>
            {section.split('\n').map((line, lineIndex, lines) => (
              <React.Fragment key={lineIndex}>
                {line}
                {lineIndex < lines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        ))}
    </div>
  );
}

export default EditableMultiSectionContent;